import { faArrowLeft, faEllipsisV } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from '@emotion/styled';

const StyledWrapper = styled.div`
  letter-spacing: 0.08px;
  color: black;
  display: flex;
  align-items: center;
  padding: 10px;
  border-bottom: 1px solid #cccccc;
`;

const StyledIconArrow = styled(FontAwesomeIcon)`
  color: #d0d0d0;
  margin-right: 10px;
`;

const StyledIconEllipsis = styled(FontAwesomeIcon)`
  margin-left: auto;
  color: #d0d0d0;
  font-size: 20px;
`;

const StyledContent = styled.div`
  text-align: left;
  color: #323232;
`;

const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <StyledWrapper>
      <StyledIconArrow icon={faArrowLeft} />
      <StyledContent>{children}</StyledContent>
      <StyledIconEllipsis icon={faEllipsisV} />
    </StyledWrapper>
  );
};

export default MobileHeader;
